
    //UPDATE THE CART ICON

    function updateCartCount() {
      fetch('/cart.js')
        .then((response) => response.json())
        .then((data) => {
          const cartCount = data.item_count;
          document.querySelector('.cart-count').textContent = cartCount;
          const cartEmpty = document.querySelector('.empty-cart');
          if (cartEmpty) {
            cartEmpty.classList.remove('empty-cart');
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }

 //search function
document.addEventListener('DOMContentLoaded', function() {
            const searchTrigger = document.querySelector('.search-trigger');
            const searchOverlay = document.getElementById('searchOverlay');
            const searchInput = document.getElementById('searchInput');
            const searchBtn = document.getElementById('searchBtn');
            const cancelBtn = document.getElementById('cancelBtn');

            // Show search overlay
            searchTrigger.addEventListener('click', function() {
                console.log("clicked");
                searchOverlay.classList.add('active');
                searchInput.focus();
            });

            // Hide search overlay
            function hideSearch() {
                searchOverlay.classList.remove('active');
                searchInput.value = '';
            }

            // Cancel button
            cancelBtn.addEventListener('click', hideSearch);

            // Search button
            searchBtn.addEventListener('click', function() {
                const searchTerm = searchInput.value.trim();
                if (searchTerm) {
                    // Perform search here
                    console.log('Searching for:', searchTerm);
                    // You can add your search logic here
                    // alert('Searching for: ' + searchTerm);
                    window.location.replace('/search?q=' + searchTerm);
                }
            });

            // Enter key to search
            searchInput.addEventListener('keypress', function(e) {
                if (e.key === 'Enter') {
                    searchBtn.click();
                }
            });

            // Escape key to close
            document.addEventListener('keydown', function(e) {
                if (e.key === 'Escape' && searchOverlay.classList.contains('active')) {
                    hideSearch();
                }
            });

            // Click outside to close
            document.addEventListener('click', function(e) {
                if (searchOverlay.classList.contains('active') && 
                    !searchOverlay.contains(e.target) && 
                    !searchTrigger.contains(e.target)) {
                    hideSearch();
                }
            });
});

    // Update cart drawer content
    function updateCartDrawer() {
        fetch('/cart?view=drawer')
            .then(response => response.text())
            .then(data => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(data, 'text/html');
                const newCartGoal = doc.getElementById('cartGoal').outerHTML;
                const newCartItems = doc.getElementById('cartItems').innerHTML;
                const newSubtotal = doc.getElementById('subtotalAmount').innerHTML;
                const checkOutBtn = doc.getElementById('cart-checkout').innerHTML;
                // console.log("doc: ", doc, "newCartItems: ",newCartItems, "newSubtotal: ", newSubtotal);
                console.log("newCartGoal: ", newCartGoal);

                document.getElementById('cartGoal').innerHTML = newCartGoal;
                document.getElementById('cartItems').innerHTML = newCartItems;
                document.getElementById('subtotalAmount').innerHTML = newSubtotal;
                document.getElementById('cart-checkout').innerHTML = checkOutBtn;
            })
            .catch(error => console.error('Error updating cart drawer:', error));
    }

function removeItem(varId) {
  console.log("varID: ", typeof(varId));

     fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: 'id=' + varId + '&quantity=0' 
    })
    .then(response => response.json())
    .then(data => {
      // Handle success
      console.log(data);
       updateCartCount();
          updateCartDrawer();
    })
    .catch(error => {
      // Handle error
      console.log(error);
    });
}

document.addEventListener('DOMContentLoaded', function() {

    const toggleCart = () => {
        document.getElementById('cartOverlay').classList.toggle('active');
        document.getElementById('cartDrawer').classList.toggle('active');
    };

    const closeCart = () => {
        document.getElementById('cartOverlay').classList.remove('active');
        document.getElementById('cartDrawer').classList.remove('active');
    };

    // Open cart when cart icon is clicked
    document.querySelector('.cart-icon').addEventListener('click', (e) => {
        e.preventDefault();
        updateCartDrawer();
        toggleCart();
    });

    // Close cart when overlay or close button is clicked
    document.getElementById('cartOverlay').addEventListener('click', closeCart);
    document.getElementById('closeCartBtn').addEventListener('click', closeCart);



    // Handle "Add to Cart" submissions
    document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
        form.addEventListener('submit', e => {
            e.preventDefault();

            fetch('/cart/add.js', {
                method: 'POST',
                body: new FormData(form)
            })
            .then(response => response.json())
            .then(cart => {
                updateCartDrawer();
                toggleCart();
            })
            .catch(error => console.error('Error adding to cart:', error));
        });
    });
 
    // Create a new view for the cart drawer
    // In your theme, you might need to create a new template file named 'cart.drawer.liquid'
    // and copy the content of your 'cart-drawer.liquid' snippet into it.

});